import { useState } from "react";
import { Button, Icon, Toast, toastManager } from "@therms/atalaya";
import { IoWarning } from "react-icons/io5";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { FaRegCheckCircle } from "react-icons/fa";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/utils/Alerts.tsx
var MsgWithDetails = ({ details, message }) => {
	const [viewDetails, setViewDetails] = useState(false);
	return /* @__PURE__ */ jsxs("div", { children: [
		/* @__PURE__ */ jsx("div", { children: message }),
		details && !viewDetails && /* @__PURE__ */ jsx(Button, {
			variant: "critical",
			subtle: true,
			onClick: () => setViewDetails(true),
			children: "View Details"
		}),
		viewDetails && /* @__PURE__ */ jsx("div", {
			className: "font-light",
			children: /* @__PURE__ */ jsx("em", { children: details })
		})
	] });
};
/**
* Alerts are for showing the user feedback on the UI that is directly in front of them (what they are looking at
* or interacting with).
*
* Notifications are for all other "notifications" that need the user's attention
*/
var Alerts = {
	error: (message, details, opts) => {
		return toastManager(/* @__PURE__ */ jsx(Toast, {
			hideCloseButton: !opts?.showCloseButton,
			icon: /* @__PURE__ */ jsx(Icon, { Icon: IoWarning }),
			title: opts?.title || "Error",
			children: /* @__PURE__ */ jsx(MsgWithDetails, {
				details,
				message
			})
		}), {
			autoClose: 3e3,
			hideProgressBar: true,
			position: toastManager.POSITION.BOTTOM_CENTER,
			variant: "critical",
			...opts || {}
		});
	},
	info: (message, opts) => {
		return toastManager(/* @__PURE__ */ jsx(Toast, {
			hideCloseButton: typeof opts?.showCloseButton === "boolean" ? !opts.showCloseButton : false,
			icon: /* @__PURE__ */ jsx(Icon, { Icon: IoIosInformationCircleOutline }),
			title: opts?.title,
			children: message
		}), {
			autoClose: 3500,
			hideProgressBar: true,
			position: toastManager.POSITION.BOTTOM_CENTER,
			variant: "info",
			...opts || {}
		});
	},
	success: (message, opts) => {
		return toastManager(/* @__PURE__ */ jsx(Toast, {
			hideCloseButton: !opts?.showCloseButton,
			icon: /* @__PURE__ */ jsx(Icon, { Icon: FaRegCheckCircle }),
			title: opts?.title || "Success",
			children: /* @__PURE__ */ jsx("div", { children: message })
		}), {
			autoClose: 2e3,
			hideProgressBar: true,
			position: toastManager.POSITION.BOTTOM_CENTER,
			variant: "positive",
			...opts || {}
		});
	}
};
//#endregion
export { Alerts };

//# sourceMappingURL=Alerts.js.map